export default __webpack_public_path__ + "img/bsDWSpQK.4d96dd81.svg";